import axios from "axios";

const apiV2BaseUrl = () => {
  if (!process.env.REACT_APP_BACKEND_BASE_API_URL) {
    throw new Error("REACT_APP_BACKEND_BASE_API_URL is not defined");
  }

  const origin = new URL(process.env.REACT_APP_BACKEND_BASE_API_URL).origin;

  return `${origin}/api/v2`;
};

export const apiClientV2 = axios.create({
  baseURL: apiV2BaseUrl(),
});

export const setApiV2AuthToken = (type: string, token: string) => {
  apiClientV2.defaults.headers.common.Authorization = `${type} ${token}`;
};

apiClientV2.interceptors.response.use((response) => response.data);
